var map = {
	"./asset.js": "./src/document-types/asset.js",
	"./babel-es6.js": "./src/document-types/babel-es6.js",
	"./datafile.js": "./src/document-types/datafile.js",
	"./markdown.js": "./src/document-types/markdown.js",
	"./packageManifest.js": "./src/document-types/packageManifest.js",
	"./page-config.js": "./src/document-types/page-config.js",
	"./project-configuration.js": "./src/document-types/project-configuration.js",
	"./screen-config.js": "./src/document-types/screen-config.js",
	"./spec.js": "./src/document-types/spec.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;



//////////////////
// WEBPACK FOOTER
// ./src/document-types nonrecursive .js$
// module id = 84
// module chunks = 0 1 2 3 4 5 6 7